module.exports = __webpack_public_path__ + "img/invited.ed1c88c5.png";